<template>
  <section :class="['subscribe-mobile', { fixed }]">
    <el-row v-if="0" class="info">
      Для записи на погрузку или для получения доп информации вы можете
      позвонить по номеру
      <el-link href="tel:+79384444420" type="primary">
        +7 938 444-44-20
      </el-link>
      <span v-if="isOpen" />
    </el-row>
    <el-row type="flex" align="center" justify="space-between" class="fw-wrap">
      <div class="info">
        Диспетчера
        <el-link href="tel:+79384444420" type="primary">
          +7 938 444-44-20
        </el-link>
        <span v-if="isOpen" />
      </div>
      <div class="info ta-r">
        Бухгалтерия
        <el-link href="tel:+79384444420" type="primary">
          +7 918 636-82-09
        </el-link>
      </div>
    </el-row>

    <el-row type="flex" justify="end" class="btn-block">
      <el-button v-if="0" type="text" class="info-btn" @click="onClick">
        {{ isOpen ? 'Скрыть' : 'Подробнее' }}
      </el-button>
    </el-row>
  </section>
</template>

<script>
export default {
  name: 'SubscribeMobile',
  props: {
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
    }
  },
  methods: {
    onClick() {
      this.isOpen = !this.isOpen
    },
  },
}
</script>

<style lang="sass">
@import "~@/assets/styles/mixins.sass"

.subscribe-mobile
  font-size: 11.5px
  line-height: normal
  color: #000000
  margin: 0
  padding: 8px 12px 10px 12px
  background: #FFFFFF
  width: 100%
  box-sizing: border-box
  @include from(450px)
    font-size: 13px
  @include from(520px)
    font-size: 16px
  &.fixed
    position: absolute
    top: 0
    background: transparent
  .info
    display: flex
    justify-content: space-between
    flex-wrap: nowrap
    margin: 0
    @include from(360px)
      margin: 0
    &:not(.ta-r)
      margin-right: 10px
  .btn-block
    margin-right: 15px
    .info-btn
      font-size: 12px
      padding: 10px 0 0
      @include from(360px)
        margin-right: 25px
        font-size: 13px
      @include from(400px)
        font-size: 14px
      @include from(500px)
        font-size: 16px
  .el-link
    margin-left: 5px
    @include from(500px)
      font-size: 16px
</style>
